(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-sharp-knife-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function syncOption(input) {
    var selectId = input.getAttribute('data-option-select');
    if (!selectId) return;

    var section = input.closest('.sharp-pdp');
    var select = section ? section.querySelector('#' + selectId) : document.getElementById(selectId);
    if (!select) return;

    select.value = input.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateGroup(input) {
    var group = input.closest('[data-sharp-option-group]');
    if (!group) return;

    group.querySelectorAll('.is-selected').forEach(function (selected) {
      selected.classList.remove('is-selected');
    });

    var label = input.closest('label');
    if (label) label.classList.add('is-selected');

    var selectedText = group.querySelector('.sharp-pdp__selected-color');
    if (selectedText) selectedText.textContent = input.value;
  }

  function getSharpProductData(section) {
    var script = section.querySelector('.product-json');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatSharpMoney(section, cents) {
    var form = section.querySelector('[data-product-form]');
    var format = form && form.getAttribute('data-product-form');

    try {
      format = format ? JSON.parse(format).money_format : null;
    } catch (error) {
      format = null;
    }

    if (format && window.theme && theme.Helpers && typeof theme.Helpers.formatMoney === 'function') {
      return theme.Helpers.formatMoney(cents, format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function updateSavingsBadge(section, variantId) {
    var badge = section.querySelector('[data-sharp-savings]');
    if (!badge) return;

    var productData = getSharpProductData(section);
    if (!productData || !productData.variants) return;

    var variant = productData.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
      badge.hidden = true;
      badge.textContent = '';
      return;
    }

    var label = badge.getAttribute('data-sharp-savings-label') || 'Save';
    badge.textContent = label + ' ' + formatSharpMoney(section, variant.compare_at_price - variant.price);
    badge.hidden = false;
  }

  function updateAddButtonPrice(section, variantId) {
    var price = section.querySelector('[data-sharp-add-price]');
    if (!price) return;

    var productData = getSharpProductData(section);
    if (!productData || !productData.variants) return;

    var variant = productData.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (!variant) return;

    price.textContent = formatSharpMoney(section, variant.price);
  }

  function getSelectedVariantId(section) {
    var productData = getSharpProductData(section);
    if (!productData || !productData.variants) return null;

    var selectedOptions = Array.prototype.map.call(section.querySelectorAll('.js-variant-selector'), function (select) {
      return select.value;
    });

    if (!selectedOptions.length) return null;

    var variant = productData.variants.find(function (item) {
      return item.options && item.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });

    return variant ? variant.id : null;
  }

  function getSelectedPackSize(section) {
    var checkedPack = section.querySelector('.sharp-pdp__bundle .sharp-pdp__option-input:checked');
    if (!checkedPack) return 1;

    var packSize = parseInt(checkedPack.getAttribute('data-pack-size'), 10);
    return Number.isNaN(packSize) ? 1 : Math.max(1, Math.min(packSize, 3));
  }

  function updateVisibleColorRows(section, packSize) {
    section.querySelectorAll('[data-sharp-color-row]').forEach(function (row) {
      var rowIndex = parseInt(row.getAttribute('data-sharp-color-row'), 10);
      var isHidden = rowIndex > packSize;
      row.hidden = isHidden;
      row.querySelectorAll('input[name^="properties["]').forEach(function (input) {
        input.disabled = isHidden;
      });
    });
  }

  function getOptionIndexForSelect(section, select) {
    if (!select) return null;
    var selects = Array.prototype.slice.call(section.querySelectorAll('.js-variant-selector'));
    var index = selects.indexOf(select);
    return index === -1 ? null : index;
  }

  function getColorOptionIndex(section) {
    var input = section.querySelector('.sharp-pdp__swatches input[data-option-select]');
    if (!input) return null;

    var select = section.querySelector('#' + input.getAttribute('data-option-select'));
    return getOptionIndexForSelect(section, select);
  }

  function getBundleOptionIndex(section) {
    var input = section.querySelector('.sharp-pdp__bundle .sharp-pdp__option-input[data-option-select]');
    if (!input) return null;

    var select = section.querySelector('#' + input.getAttribute('data-option-select'));
    return getOptionIndexForSelect(section, select);
  }

  function getSelectedBundleValue(section) {
    var checked = section.querySelector('.sharp-pdp__bundle .sharp-pdp__option-input:checked');
    return checked ? checked.value : null;
  }

  function findColorVariant(productData, bundleIndex, bundleValue, colorIndex, colorValue) {
    if (!productData || !productData.variants || colorIndex === null) return null;

    return productData.variants.find(function (variant) {
      if (!variant.options || variant.options[colorIndex] !== colorValue) return false;
      if (bundleIndex !== null && bundleValue !== null && variant.options[bundleIndex] !== bundleValue) return false;
      return true;
    }) || null;
  }

  /*
   * Only the Set 1 swatch is wired to the real variant option (data-sync-variant-option);
   * Set 2/3 swatches are line-item properties with no variant of their own, so their
   * out-of-stock state has to be looked up and enforced separately here.
   */
  function updateColorAvailability(section) {
    var productData = getSharpProductData(section);
    if (!productData || !productData.variants) return;

    var colorIndex = getColorOptionIndex(section);
    if (colorIndex === null) return;

    var bundleIndex = getBundleOptionIndex(section);
    var bundleValue = bundleIndex !== null ? getSelectedBundleValue(section) : null;
    var packSize = getSelectedPackSize(section);
    var hasUnavailableSelection = false;

    section.querySelectorAll('[data-sharp-color-row]').forEach(function (row) {
      var rowIndex = parseInt(row.getAttribute('data-sharp-color-row'), 10);
      if (rowIndex > packSize) return;

      row.querySelectorAll('.sharp-pdp__swatch').forEach(function (swatch) {
        var input = swatch.querySelector('input[name^="properties["]');
        if (!input) return;

        var variant = findColorVariant(productData, bundleIndex, bundleValue, colorIndex, input.value);
        var available = variant ? variant.available : true;

        swatch.classList.toggle('is-unavailable', !available);
        input.disabled = !available;

        if (!available && input.checked) hasUnavailableSelection = true;
      });
    });

    var addButton = section.querySelector('.sharp-pdp__add');
    if (!addButton) return;

    var rowOneUnavailable = false;
    var selectedVariantId = getSelectedVariantId(section);
    if (selectedVariantId) {
      var currentVariant = productData.variants.find(function (item) {
        return String(item.id) === String(selectedVariantId);
      });
      rowOneUnavailable = currentVariant ? !currentVariant.available : false;
    }

    addButton.disabled = rowOneUnavailable || hasUnavailableSelection;
  }

  function stashGalleryImage(img) {
    if (!img || img.dataset.galleryStash === 'pending' || img.dataset.galleryStash === 'done') return;
    img.dataset.galleryStash = 'pending';
    if (img.getAttribute('src')) {
      img.dataset.gallerySrc = img.getAttribute('src');
      img.removeAttribute('src');
    }
    if (img.getAttribute('srcset')) {
      img.dataset.gallerySrcset = img.getAttribute('srcset');
      img.removeAttribute('srcset');
    }
  }

  function restoreGalleryImage(img) {
    if (!img || img.dataset.galleryStash !== 'pending') return;
    if (img.dataset.gallerySrc) img.setAttribute('src', img.dataset.gallerySrc);
    if (img.dataset.gallerySrcset) img.setAttribute('srcset', img.dataset.gallerySrcset);
    img.dataset.galleryStash = 'done';
  }

  function initSharpGalleryDefer() {
    document.querySelectorAll('.sharp-pdp [data-sharp-gallery]').forEach(function (gallery) {
      /* Mobile track is a horizontal scroll carousel — all slides must keep src/srcset. */
      gallery.querySelectorAll('[data-sharp-gallery-mobile-slide] img').forEach(restoreGalleryImage);

      gallery.querySelectorAll('[data-sharp-gallery-slide]').forEach(function (slide, index) {
        if (index === 0) {
          restoreGalleryImage(slide.querySelector('img'));
          return;
        }
        stashGalleryImage(slide.querySelector('img'));
      });
    });
  }

  function selectGallerySlide(gallery, index) {
    var selectedThumb = null;
    var normalizedIndex = String(index);

    gallery.querySelectorAll('[data-sharp-gallery-thumb]').forEach(function (thumb) {
      var isSelected = thumb.getAttribute('data-sharp-gallery-thumb') === normalizedIndex;
      thumb.classList.toggle('is-selected', isSelected);
      thumb.setAttribute('aria-current', isSelected ? 'true' : 'false');
      if (isSelected) selectedThumb = thumb;
    });

    if (selectedThumb) {
      selectedThumb.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }

    gallery.querySelectorAll('[data-sharp-gallery-slide]').forEach(function (slide) {
      var isSelected = slide.getAttribute('data-sharp-gallery-slide') === normalizedIndex;
      slide.classList.toggle('is-selected', isSelected);
      if (isSelected) restoreGalleryImage(slide.querySelector('img'));
    });

    var mobileSlide = gallery.querySelector('[data-sharp-gallery-mobile-slide="' + normalizedIndex + '"]');
    if (mobileSlide) restoreGalleryImage(mobileSlide.querySelector('img'));
    if (mobileSlide && window.matchMedia('(max-width: 740px)').matches) {
      mobileSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  function getSelectedGalleryIndex(gallery) {
    var selectedSlide = gallery.querySelector('[data-sharp-gallery-slide].is-selected');
    if (!selectedSlide) return 0;

    var selectedIndex = parseInt(selectedSlide.getAttribute('data-sharp-gallery-slide'), 10);
    return Number.isNaN(selectedIndex) ? 0 : selectedIndex;
  }

  document.addEventListener('click', function (event) {
    var directionButton = event.target.closest('[data-sharp-gallery-direction]');
    if (directionButton) {
      var directionGallery = directionButton.closest('[data-sharp-gallery]');
      if (!directionGallery) return;

      var slides = directionGallery.querySelectorAll('[data-sharp-gallery-slide]');
      if (!slides.length) return;

      var currentIndex = getSelectedGalleryIndex(directionGallery);
      var direction = directionButton.getAttribute('data-sharp-gallery-direction');
      var nextIndex = direction === 'prev' ? currentIndex - 1 : currentIndex + 1;

      if (nextIndex < 0) nextIndex = slides.length - 1;
      if (nextIndex >= slides.length) nextIndex = 0;

      selectGallerySlide(directionGallery, nextIndex);
      return;
    }

    var thumb = event.target.closest('[data-sharp-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-sharp-gallery]');
    if (!gallery) return;

    selectGallerySlide(gallery, thumb.getAttribute('data-sharp-gallery-thumb'));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.sharp-pdp__option-input, .sharp-pdp__swatch input[name^="properties"]');
    var variantInput = event.target.closest('.formVariantId');

    if (variantInput) {
      var variantSection = variantInput.closest('.sharp-pdp');
      if (variantSection) {
        updateSavingsBadge(variantSection, variantInput.value);
        updateAddButtonPrice(variantSection, variantInput.value);
      }
      return;
    }

    if (!input) return;

    updateGroup(input);
    syncOption(input);

    var section = input.closest('.sharp-pdp');
    if (section) {
      var selectedVariantId = getSelectedVariantId(section);
      if (selectedVariantId) {
        updateSavingsBadge(section, selectedVariantId);
        updateAddButtonPrice(section, selectedVariantId);
      }
    }

    if (section && input.hasAttribute('data-pack-size')) {
      updateVisibleColorRows(section, getSelectedPackSize(section));
    }

    if (section) {
      updateColorAvailability(section);
    }
  });

  document.querySelectorAll('.sharp-pdp').forEach(function (section) {
    updateVisibleColorRows(section, getSelectedPackSize(section));
    updateColorAvailability(section);
  });

  initSharpGalleryDefer();

  document.addEventListener('submit', function (event) {
    var section = event.target.closest('.sharp-pdp');
    if (!section) return;

    updateVisibleColorRows(section, getSelectedPackSize(section));
    updateColorAvailability(section);

    var addButton = section.querySelector('.sharp-pdp__add');
    if (addButton && addButton.disabled) {
      event.preventDefault();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
